import { useEffect, useState } from "react";
import { collection, getDocs , deleteDoc  , doc} from "firebase/firestore";
import { db, auth } from "./Firebase";
import Navbar from "./Navbar";
import Spinner from "./Spinner";
import { Trash2 } from "lucide-react";
import { toast, ToastContainer } from "react-toastify";
import { useDispatch } from "react-redux";
import { addToCart } from "../Redux/cart/cartSlice";

const Liked = () => {
  const dispatch = useDispatch();
  const [likedProducts, setLikedProducts] = useState(null);
  const [userId , setUserId] = useState(null);
  const handleDisLike = async(id)=>{
    console.log(id)
    try {
      const productRef = doc(db , "LikedCards" , userId , "products" , id )
      await deleteDoc(productRef)
      setLikedProducts((prev) => prev.filter((product) => product.id !== id));
    } catch (error) {
      toast.error(error.message , {position : "top-right"})
    }
  }
  const handleCart = (card)=>{
    dispatch(addToCart(card))
    toast.success("Successfully Added to cart", {position : "top-right"})
  }
  useEffect(() => {
    const fetchLikedProducts = async (user) => {
      if (!user) {
        console.log("User not logged in");
        setLikedProducts([]); 
        return;
      }
      try {
        setUserId(user.uid)
        const likedProductsRef = collection(
          db,
          "LikedCards",
          user.uid,
          "products"
        );
        
        const querySnapshot = await getDocs(likedProductsRef);

        const products = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        console.log("Fetched Products:", products);
        setLikedProducts(products);
      } catch (error) {
        console.error("Error fetching liked products:", error.message);
        setLikedProducts([]); 
      }
    };

    const unsubscribe = auth.onAuthStateChanged((user) => {
      fetchLikedProducts(user);

    });

    return () => unsubscribe();
  }, []);

  
  if (likedProducts === null) {
    return <Spinner />;
  }

  return (
    <div className="bg-slate-100/50 h-screen">
      <Navbar />
      <h2 className="text-2xl mt-4 font-bold mb-4 text-center ">
        Liked Products
      </h2>
      <div className="max-w-[60%] mx-auto ">
        {likedProducts.length > 0 ? (
          likedProducts.map((product) => (
            <div
              key={product.card.id}
              className="border p-4 rounded-lg shadow flex justify-between items-center object-center object-contain relative mb-6 bg-white"
            >
              <p className="absolute top-[-2px] left-0 bg-red-500 text-white rounded-tl-lg p-1">{product.card.discount}% off</p>
              <img
                src={product.card.images?.[0] || ""}
                alt={product.card.name || "No Name"}
                className="w-32 h-32 object-cover rounded"
              />
              <h3 className="text-lg font-semibold mt-2">
                {product.card.name || "No Name"}
              </h3>
              <p className="text-sm text-gray-500 w-[30%]">
                {product.card.description || "No Description"}
              </p>
              <p className="font-bold text-lg mt-1">
                ${product.card.finalPrice || "N/A"}
              </p>
              <div className="flex flex-col items-center gap-3">
                <button className="bg-violet-500 text-white text-center p-2 rounded-xl mt-2 cursor-pointer hover:bg-violet-800" onClick={()=>handleCart(product.card)}>
                  Add To Cart
                </button>
                <div className="flex gap-2 items-center">
                <button className="bg-red-500/80 p-2 rounded-lg text-white/80 hover:bg-red-500 transition-colors duration-400" onClick={()=>handleDisLike(product.id)}><Trash2/></button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p className="text-center">No liked products yet.</p>
        )}
      </div>
      <ToastContainer/>
    </div>
  );
};

export default Liked;
